import { JSX } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Card, cn, getMotionProps } from '@dashboard/ui'

interface PageSocialPreviewProps {
  title: string
  desc: string
  imageUrl?: string
}

export const PageSocialPreview = ({ title, desc, imageUrl }: PageSocialPreviewProps) => (
  <Card size="sm" color="secondary" className="flex flex-col gap-3 p-3 text-text-tertiary">
    <div className={cn('cursor-default select-none ', 'flex flex-col gap-1.5')}>
      <span
        className={cn(
          'line-clamp-1 text-caption-sm',
          '[mask-image:linear-gradient(to_right,black_90%,transparent_100%)]',
        )}
        title={title}
      >
        {title}
      </span>
      {desc && <p className="whitespace-pre-line text-paragraph-xs font-normal">{desc}</p>}
    </div>
    <AnimatePresence>{imageUrl && <Image src={imageUrl} />}</AnimatePresence>
  </Card>
)

const imageMotionProps = getMotionProps({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
})

function Image(props: Pick<JSX.IntrinsicElements['img'], 'src'>) {
  return <motion.img {...imageMotionProps} {...props} className="aspect-[16/9] self-stretch rounded-md object-cover" />
}
